module.exports = __webpack_public_path__ + "assets/img/592fcb6dbd3002711d72cf97de608bfb.svg";